__turbopack_context__.v({
  "icon": "wou5ia_icon",
  "wrapper": "wou5ia_wrapper",
});
